import styled from 'styled-components'

export const ModalContainer = styled.div`
  padding: 2rem;
  min-width: 400px;
  max-width: 48rem;
  background-color: ${({ theme }) => theme.palette.background.default};

  /* Center the modal in the middle of the screen */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const Title = styled.h2`
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.palette.text.primary};
`

export const Description = styled.p`
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.palette.text.primary};
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`
